module.exports = __webpack_public_path__ + "static/media/tg-white.c35f1c68.svg";